import React, { useState } from "react";
import { Button, Typography } from "antd";
import "./ExpandableNoteText.css";

const ExpandableNoteText = ({
  text,
  rows = 2,
  className,
  style,
  toggleClassName = "progress-notes-toggle",
}) => {
  const [expanded, setExpanded] = useState(false);
  const [truncated, setTruncated] = useState(false);
  const value = (text ?? "").toString();
  const showToggle = truncated || expanded;

  return (
    <div className={className}>
      <Typography.Paragraph
        style={{ ...style, marginBottom: 0 }}
        ellipsis={
          expanded
            ? false
            : {
                rows,
                onEllipsis: setTruncated,
              }
        }
      >
        {value}
      </Typography.Paragraph>
      {showToggle && (
        <Button
          type="link"
          size="small"
          className={toggleClassName}
          style={{ padding: 0, height: "auto" }}
          onClick={() => setExpanded((prev) => !prev)}
        >
          {expanded ? "less" : "more"}
        </Button>
      )}
    </div>
  );
};

export default ExpandableNoteText;
